import React, { Component } from 'react';
import { connect } from "react-redux";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  TextField, FormHelperText
} from "@material-ui/core";
import AddBoxIcon from "@material-ui/icons/AddBox";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { CreateLeadPlan, UpdateLeadPlan, DeleteLeadPlan } from './LeadsAction';
import { DatePicker } from 'antd';
import 'antd/dist/antd.css';
import locale from "antd/es/date-picker/locale/de_DE";
import moment from "moment";
import NumberFormat from "react-number-format";
import isEmpty from 'lodash.isempty';
import sortBy from 'lodash/sortBy';

const dateFormat = 'YYYY';
const currentYear = moment().format(dateFormat);

class LeadPlans extends Component {

  constructor(props) {
    super(props);
    this.state = {
      LeadPlanSaveUpdateDialogOpen: false,
      LeadPlanDeleteDialogOpen: false,
      lead_plan_row: '',
      editMode: false,
      year: '',
      year_exists_error: '',
      probability: '',
      plan2: '',
      plan3: '',
      isProbabilityEmpty: false,
      isProbabilityRange: false,
      isPlan3Empty: false,
      lead_plans: [],
      SameYearNotAllowedDialogOpen: false
    }
  }

  componentDidMount() {
    this.setState({
      lead_id: this.props.lead_id,
      updateMode: this.props.updateMode,
      lead_plans: this.props.existing_lead_plans,
    })
  }

  componentDidUpdate(prevProps, prevState) {
    const { updated_lead_plans, error_validation, must_contain_lead_plan } = this.props;
    if (prevProps.must_contain_lead_plan !== must_contain_lead_plan) {
      this.setState({ must_contain_lead_plan: must_contain_lead_plan })
    }
    if (prevProps.updated_lead_plans !== updated_lead_plans) {
      this.setState({
        lead_plans: updated_lead_plans,
        year: '',
        probability: '',
        plan2: '',
        plan3: '',
        LeadPlanSaveUpdateDialogOpen: false,
        year_exists_error: '',
        must_contain_lead_plan: ''
      });
    }
    if (prevProps.error_validation !== error_validation) {
      if (error_validation.lead["lead_plans.base"] && error_validation.lead["lead_plans.base"][0].split('base')[1].length > 0) {
        this.setState({ year_exists_error: error_validation.lead["lead_plans.base"][0].split('base')[1], LeadPlanSaveUpdateDialogOpen: true })
      }
    }
  }

  createLeadPlanDialog = () => {
    this.setState({
      LeadPlanSaveUpdateDialogOpen: true
    });
  }

  saveLeadPlanDialog = () => {
    const { updateMode, lead_id, year, probability, plan2, plan3 } = this.state;
    if (updateMode) {
      if (!isEmpty(probability) && probability <= 100 && !isEmpty(plan3)) {
        this.props.CreateLeadPlan(lead_id, year, probability, plan2, plan3);
      } else {
        if (isEmpty(probability))
          this.setState({ isProbabilityEmpty: true, isProbabilityRange: false })
        else if (!isEmpty(probability) && (probability > 100 || probability < 0))
          this.setState({ isProbabilityRange: true, isProbabilityEmpty: false })
        else if (isEmpty(plan3))
          this.setState({ isPlan3Empty: true })
      }

    } else {
      if (!isEmpty(probability) && probability <= 100 && !isEmpty(plan3)) {
        const yearAlreadyExists = this.state.lead_plans.some(function (o) {
          return o["year"] === year;
        })

        if (yearAlreadyExists) {
          this.setState({
            SameYearNotAllowedDialogOpen: true
          });
        } else {
          this.setState(state => ({
            lead_plans: [...state.lead_plans, {
              id: Date.now(),
              year: year,
              probability: probability,
              plan2: plan2,
              plan3: plan3
            }]
          }));

          this.props.plansClick({
            id: Date.now(),
            year: year,
            probability: probability,
            plan2: plan2,
            plan3: plan3
          }
          );

          this.setState({
            year: '',
            probability: '',
            plan2: '',
            plan3: '',
            LeadPlanSaveUpdateDialogOpen: false,
          });
        }

      } else {
        if (isEmpty(probability))
          this.setState({ isProbabilityEmpty: true, isProbabilityRange: false })
        else if (!isEmpty(probability) && (probability > 100 || probability < 0))
          this.setState({ isProbabilityRange: true, isProbabilityEmpty: false })
        else if (isEmpty(plan3))
          this.setState({ isPlan3Empty: true })
      }
    }
  }

  updateLeadPlanDialog = () => {
    const { lead_id, plan_id, year, probability, plan2, plan3 } = this.state;
    if (!isEmpty(probability) && probability <= 100 && !isEmpty(plan3)) {
      this.props.UpdateLeadPlan(lead_id, plan_id, year, probability, plan2, plan3);
      this.setState({
        year: '',
        probability: '',
        plan2: '',
        plan3: '',
        LeadPlanSaveUpdateDialogOpen: false,
        editMode: false
      });
    } else {
      if (isEmpty(probability))
        this.setState({ isProbabilityEmpty: true, isProbabilityRange: false })
      else if (!isEmpty(probability) && (probability > 100 || probability < 0))
        this.setState({ isProbabilityRange: true, isProbabilityEmpty: false })
      else if (isEmpty(plan3))
        this.setState({ isPlan3Empty: true })
    }
  }

  addLeadPlanDialog = () => {
    const { updateMode, editMode, newFieldsEditMode } = this.state;
    if (updateMode && editMode) {
      this.updateLeadPlanDialog();
    } else if (newFieldsEditMode) {
      const { lead_id, lead_plans, year, probability, plan2, plan3 } = this.state;
      const new_lead = {
        id: lead_id,
        year,
        probability,
        plan2,
        plan3,
      };
      const updated_lead_plans = lead_plans.map((lead) => lead.id === lead_id ? new_lead : lead);
      this.setState({
        lead_plans: updated_lead_plans,
        year: '',
        probability: '',
        plan2: '',
        plan3: '',
        newFieldsEditMode: false,
        LeadPlanSaveUpdateDialogOpen: false
      });
    } else {
      this.saveLeadPlanDialog();
    }
  }

  handleUpdateFields = (lead_plan) => {
    const { updateMode } = this.state;
    if (updateMode) {
      this.setState({
        plan_id: lead_plan.id,
        year: lead_plan.year,
        probability: lead_plan.probability,
        plan2: lead_plan.plan2,
        plan3: lead_plan.plan3,
        LeadPlanSaveUpdateDialogOpen: true,
        editMode: true
      });
    } else {
      this.setState(state => ({
        lead_id: lead_plan.id,
        year: lead_plan.year,
        probability: lead_plan.probability,
        plan2: lead_plan.plan2,
        plan3: lead_plan.plan3,
        LeadPlanSaveUpdateDialogOpen: true,
        newFieldsEditMode: true,
      }));
    }
  }

  launchDeleteLeadPlanDialog = (lead_plan) => {
    this.setState({ LeadPlanDeleteDialogOpen: true, lead_plan_row: lead_plan });
  }

  handleRemoveFields = () => {
    const { updateMode, lead_plan_row } = this.state;
    if (updateMode) {
      this.props.DeleteLeadPlan(lead_plan_row.lead_id, lead_plan_row.id);
    } else {
      this.setState(prevState => ({ lead_plans: prevState.lead_plans.filter(lead_offer_rec => lead_offer_rec !== lead_plan_row) }));
    }
    this.setState({ LeadPlanDeleteDialogOpen: false });
  };

  closeDeleteLeadPlanDialog = () => {
    this.setState({ LeadPlanDeleteDialogOpen: false })
  }

  closeLeadPlanDialog = () => {
    this.setState({
      year: '',
      probability: '',
      plan2: '',
      plan3: '',
      isYearEmpty: false,
      isProbabilityEmpty: false,
      isPlan3Empty: false,
      LeadPlanSaveUpdateDialogOpen: false,
      year_exists_error: '',
      isProbabilityRange: false
    });
  }

  closeSameYearNotAllowedDialog = () => {
    this.setState({ SameYearNotAllowedDialogOpen: false })
  }

  calculatePlanIIField = () => {
    const { plan3, probability } = this.state;
    const plan2Field = parseFloat(0.01 * probability * plan3)
    this.setState({ plan2: plan2Field })
  }

  getFormattedNumber(value) {
    return <NumberFormat
      value={value}
      displayType={'text'}
      decimalSeparator={","}
      decimalScale={0}
      thousandSeparator={"."}
      isNumericString={true}
    />
  }

  render() {

    const { LeadPlanSaveUpdateDialogOpen, LeadPlanDeleteDialogOpen, year, year_exists_error, probability, plan2, plan3, lead_plans, isProbabilityEmpty, isProbabilityRange, isPlan3Empty, SameYearNotAllowedDialogOpen, must_contain_lead_plan } = this.state;
    const access_rights = JSON.parse(localStorage.getItem('access_right'))

    return (
      <React.Fragment>
        {must_contain_lead_plan && <FormHelperText error>{must_contain_lead_plan}</FormHelperText>}
        <Grid item xs={2} style={Number(access_rights.leads) === 2 ? { lineHeight: '1.5' } : { margin: '10px 0', lineHeight: '1.5' }}>
          <div className="partner-div partner-div-1">
            Planung
                        {Number(access_rights.leads) === 2 ?
              <IconButton>
                <AddBoxIcon style={{ marginRight: '10px', cursor: 'pointer' }} onClick={() => { this.createLeadPlanDialog() }} />
              </IconButton> : ''}
          </div>
        </Grid>

        <TableContainer component={Paper} className="lead_plan_offer">
          <Table size="small" aria-label="dense table">
            <TableHead>
              <TableRow>
                {Number(access_rights.leads) === 2 ? <TableCell align="right" colSpan={2} style={{ width: '10%' }}></TableCell> : ''}
                <TableCell align="right"></TableCell>
                <TableCell align="center" colSpan={3}>Jahresplan</TableCell>
                <TableCell align="center" colSpan={2}>Realisiert / Ist</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                {Number(access_rights.leads) === 2 ? <TableCell align="right" colSpan={2}></TableCell> : ''}
                <TableCell align="center">Jahr</TableCell>
                <TableCell align="right">%</TableCell>
                <TableCell align="right">Plan II</TableCell>
                <TableCell align="right">Plan III</TableCell>
                <TableCell align="right">Honorar</TableCell>
                <TableCell align="right">NK</TableCell>
              </TableRow>
              {
                sortBy(lead_plans, "year").map((lead_plan, index) => (
                  <TableRow key={`mi-${index}`} className={index % 2 == 0 ? 'grey_row' : ''}>
                    {Number(access_rights.leads) === 2 ?
                      <TableCell align="right" colSpan={2} className={'no_border'} style={{ width: '6%' }}>
                        <IconButton>
                          <EditIcon onClick={() => this.handleUpdateFields(lead_plan)} />
                        </IconButton>
                        <IconButton>
                          <DeleteIcon onClick={() => this.launchDeleteLeadPlanDialog(lead_plan)} />
                        </IconButton>
                      </TableCell> : ''}
                    <TableCell align="center">{lead_plan.year}</TableCell>
                    <TableCell align="right">{this.getFormattedNumber(lead_plan.probability)}</TableCell>
                    <TableCell align="right">{this.getFormattedNumber(lead_plan.plan2)}</TableCell>
                    <TableCell align="right">{this.getFormattedNumber(lead_plan.plan3)}</TableCell>
                    <TableCell align="right">{this.getFormattedNumber(lead_plan.honorar)}</TableCell>
                    <TableCell align="right">{this.getFormattedNumber(lead_plan.nk)}</TableCell>
                  </TableRow>
                ))
              }
            </TableBody>
          </Table>
        </TableContainer>

        <Dialog open={LeadPlanSaveUpdateDialogOpen} maxWidth="sm" style={{ maxWidth: '435px !important' }}>
          <DialogTitle id="form-dialog-title" style={{ textAlign: 'center' }}>Planung</DialogTitle>
          <DialogContent className="p-60">
            {year_exists_error && <FormHelperText error>{year_exists_error}</FormHelperText>}
            <Grid container spacing={1} justify="center">
              <Grid item xs={4} style={{ lineHeight: '2.5' }}>
                Jahr
                            </Grid>
              <Grid item xs={8}>
                <DatePicker
                  locale={locale}
                  picker="year"
                  fullWidth
                  required
                  size="small"
                  value={year === '' ? this.setState({ year: currentYear }) : moment(year, dateFormat)}
                  format={dateFormat}
                  placeholder="YYYY"
                  allowClear={false}
                  bordered={false}
                  onChange={(e) => {
                    let date = moment(e).format(dateFormat);
                    this.setState({ year: date })
                  }}
                />
              </Grid>
              <Grid item xs={4} style={{ lineHeight: '2.5' }}>
                Wahrscheinlichkeit
                            </Grid>
              <Grid item xs={8}>
                <TextField required={true} fullWidth inputProps={{ maxLength: 10 }} size="small"
                  variant="outlined"
                  value={probability === '' ? 0 : Number(probability)}
                  onChange={(e) => {
                    this.setState({
                      probability: e.target.value.replace(/\D/, ''),
                      isProbabilityEmpty: false,
                      isProbabilityRange: false
                    }, () => {
                      this.calculatePlanIIField()
                    })
                  }}
                  style={{ direction: 'rtl' }}
                />
                <FormHelperText error>{isProbabilityEmpty && isProbabilityEmpty ? 'Bitte geben Sie die Wahrscheinlichkeit ein' : ''}</FormHelperText>
                <FormHelperText error>{isProbabilityRange && isProbabilityRange ? 'Die Wahrscheinlichkeit darf nicht größer als 100 oder kleiner als 0 sein' : ''}</FormHelperText>
              </Grid>
              <Grid item xs={4} style={{ lineHeight: '2.5' }}>
                Plan II
                            </Grid>
              <Grid item xs={8}>
                <NumberFormat
                  customInput={TextField} required={true} fullWidth
                  inputProps={{ maxLength: 10 }} size="small" variant="outlined"
                  value={plan2 === '' ? 0 : Number(plan2)}
                  decimalSeparator={","} decimalScale={0} allowNegative={false} thousandSeparator={"."}
                  onValueChange={(values) => this.setState({
                    plan2: values.value
                  })}
                  style={{ direction: 'rtl' }}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={4} style={{ lineHeight: '2.5' }}>
                Plan III
                            </Grid>
              <Grid item xs={8}>
                <NumberFormat
                  customInput={TextField} required={true} fullWidth
                  inputProps={{ maxLength: 10 }} size="small" variant="outlined"
                  value={plan3 === '' ? 0 : Number(plan3)}
                  decimalSeparator={","} decimalScale={0} allowNegative={false} thousandSeparator={"."}
                  onValueChange={(values) => {
                    this.setState({
                      plan3: values.value,
                      isPlan3Empty: false
                    }, () => {
                      this.calculatePlanIIField()
                    })
                  }}
                  style={{ direction: 'rtl' }}
                />
                <FormHelperText
                  error>{isPlan3Empty && isPlan3Empty ? 'Bitte geben Sie Plan 3 ein' : ''}</FormHelperText>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions style={{ justifyContent: 'center' }}>
            <Button variant="outlined" className="m-10" onClick={this.addLeadPlanDialog}
              color="primary">
              Speichern
                        </Button>
            <Button variant="outlined" className="m-10" onClick={this.closeLeadPlanDialog}
              color="secondary">
              Abbrechen
                        </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={LeadPlanDeleteDialogOpen}>
          <DialogTitle>Planen Löschen</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Bist du sicher?
                        </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleRemoveFields} variant="outlined" size="small" color="primary"
              autoFocus>
              Bestätigen
                        </Button>
            <Button onClick={this.closeDeleteLeadPlanDialog} variant="outlined" color="secondary"
              size='small'>
              Abbrechen
                        </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={SameYearNotAllowedDialogOpen}>
          <DialogTitle>Bestätigung</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Für dieses Jahr existiert bereits ein Plan
                        </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.closeSameYearNotAllowedDialog} variant="outlined" color="secondary"
              size='small'>
              Abbrechen
                        </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({ leads }) => {
  return {
    isloading: leads.loading,
    updated_lead_plans: leads.lead_plans,
    error_validation: leads.error_message,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    CreateLeadPlan: (lead_id, year, probability, plan2, plan3) => dispatch(CreateLeadPlan(lead_id, year, probability, plan2, plan3)),
    UpdateLeadPlan: (lead_id, plan_id, year, probability, plan2, plan3) => dispatch(UpdateLeadPlan(lead_id, plan_id, year, probability, plan2, plan3)),
    DeleteLeadPlan: (lead_id, lead_plan_id) => dispatch(DeleteLeadPlan(lead_id, lead_plan_id))
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(LeadPlans);